import React, { useState, useEffect } from "react";
import { useEmailSections } from "../../Context/EmailSectionContext";
import { addOpacity } from "../../../helpers";
import StyleControls from "./StyleControls";


const TitleDescription = (props) => {
  const { id, previewMode, styleSettings = {}, data } = props;
  const { sections, updateSection } = useEmailSections();

  const sectionData = previewMode
    ? data || props
    : sections.find(section => section.id === id) || {};

  const {
    title = "",
    description = "",
    alignment = "center",
    spacing = "normal",
    component_name = "TitleDescription"
  } = sectionData;

  const [isEditing, setIsEditing] = useState(false);
  const [localTitle, setLocalTitle] = useState(title);
  const [localDescription, setLocalDescription] = useState(description);
  const [localAlignment, setLocalAlignment] = useState(alignment);
  const [localSpacing, setLocalSpacing] = useState(spacing);

  useEffect(() => {
    setLocalTitle(title);
    setLocalDescription(description);
    setLocalAlignment(alignment);
    setLocalSpacing(spacing);
  }, [id]);

  // Merge section-specific styles with parent styles
  const sectionStyleSettings = sectionData?.styleSettings || {};
  const effectiveStyleSettings = {
    ...styleSettings,  // Parent styles (defaults)
    ...sectionStyleSettings  // Section-specific overrides
  };
  const {
    primaryColor = "#333333",
    secondaryColor = "#a1894c",
    fontFamily = "helvetica, 'helvetica neue', arial, verdana, sans-serif",
    backgroundColor = "#ffffff"
  } = effectiveStyleSettings;

  const handleSave = () => {
    const currentSection = sections.find(section => section.id === id) || {};
    updateSection(id, {
      id,
      component_name,
      title: localTitle,
      description: localDescription,
      alignment: localAlignment,
      spacing: localSpacing,
      styleSettings: {
        ...(currentSection.styleSettings || {}) // Preserve existing styleSettings
      }
    });
    setIsEditing(false);
  };

  if (isEditing && !previewMode) {
    return (
      <div className="email-component title-description-editor p-3 mb-3 border rounded">
        <h4>Edit Title & Description</h4>
        <input className="form-control mb-2" value={localTitle} onChange={e => setLocalTitle(e.target.value)} placeholder="Title" />
        <textarea className="form-control mb-2" value={localDescription} onChange={e => setLocalDescription(e.target.value)} placeholder="Description" />
        <div className="mb-2">
          <label>Alignment</label>
          <select className="form-select" value={localAlignment} onChange={e => setLocalAlignment(e.target.value)}>
            <option value="left">Left</option>
            <option value="center">Center</option>
            <option value="right">Right</option>
          </select>
        </div>
        {/* <div className="mb-2">
          <label>Spacing</label>
          <select className="form-select" value={localSpacing} onChange={e => setLocalSpacing(e.target.value)}>
            <option value="compact">Compact</option>
            <option value="normal">Normal</option>
            <option value="loose">Loose</option>
          </select>
        </div> */}
        <div className="d-flex justify-content-end mt-3">
          <button className="btn btn-outline-secondary me-2" onClick={() => setIsEditing(false)}>Cancel</button>
          <button className="btn bgprimary rounded" onClick={handleSave}>Save Changes</button>
        </div>
      </div>
    );
  }

  // VIEW/PREVIEW
  return (
    <>
    
   
      {!previewMode && (
    <div className="email-component title-description mb-3" >
        <div className="component-controls mb-2 d-flex justify-content-between align-items-center flex-wrap gap-2">
          <StyleControls 
            id={id} 
            componentName={component_name}
            styleSettings={styleSettings}
            previewMode={previewMode}
          />
          <button className="btn btn-sm btn-outline-primary" onClick={() => setIsEditing(true)}>Edit</button>
        </div>
         </div>
      )}
    <table width="100%" cellpadding="0" cellspacing="0" border="0" style={{ fontFamily, backgroundColor }}>
  <tr>
    <td align={localAlignment || "left"} style={{ padding: '16px', fontFamily, backgroundColor }}>
      <div
        style={{
          textAlign: localAlignment || "left",
          fontFamily
        }}
      >
        <div
          style={{
            fontSize: '24px',
            fontWeight: 'bold',
            color: primaryColor,
            marginBottom: '8px',
            fontFamily
          }}
        >
          {localTitle}
        </div>
        <div
          style={{
            fontSize: '16px',
            color: primaryColor,
            fontFamily
          }}
        >
          {localDescription}
        </div>
      </div>
    </td>
  </tr>
</table>

  
    </>
  );
};

export default TitleDescription;